'use strict';

exports.__esModule = true;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactIntl = require('react-intl');

var _intlProviderWrapper = require('./intl-provider-wrapper');

var _intlProviderWrapper2 = _interopRequireDefault(_intlProviderWrapper);

var _reviewItem = require('../../src/styles/review-item.scss');

var _reviewItem2 = _interopRequireDefault(_reviewItem);

var _style = require('../../src/styles/style.scss');

var _style2 = _interopRequireDefault(_style);

var _stars = require('./stars');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ReviewItem = function ReviewItem(props) {
    var styles = props.classNames ? (0, _extends3.default)({}, _reviewItem2.default, props.classNames) : _reviewItem2.default;
    var wrapperClassName = styles['review-item'] + ' ' + (props.additionalClass ? " " + props.additionalClass : " ");
    var wrapperStyle = props.wrapperStyle;
    return _react2.default.createElement(
        'div',
        {
            className: [wrapperClassName, props.showFrame && styles["review-item_frame"]].join(" "),
            style: wrapperStyle
        },
        _react2.default.createElement(
            'div',
            { className: styles['review-item__stars'] },
            _react2.default.createElement(_stars.Stars, { rate: props.rate, isReview: true })
        ),
        props.showSpecialistInfo && (props.showSpecialistImage && props.specialistImage || props.showSpecialistName && props.specialistName) && _react2.default.createElement(
            'div',
            { className: styles['review-item__subject'] },
            props.showSpecialistImage && props.specialistImage && _react2.default.createElement(
                'div',
                { className: styles['review-item__subject-image'] },
                _react2.default.createElement('img', { src: props.specialistImage, alt: props.specialist })
            ),
            props.showSpecialistName && props.specialistName && _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'span',
                    { className: _style2.default["mr-4"] },
                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'ReviewItem.reviewing'
                    })
                ),
                _react2.default.createElement(
                    'div',
                    { className: styles['review-item__subject-name'] },
                    props.specialistName
                )
            )
        ),
        _react2.default.createElement(
            'div',
            { className: styles['review-item__content'], style: props.contentStyle },
            props.content
        ),
        _react2.default.createElement(
            'div',
            { className: styles['review-item__info'] },
            _react2.default.createElement(
                'div',
                null,
                props.date
            ),
            props.isReviewVerified && _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'ReviewItem.by_a_verified_patient'
                })
            ),
            props.showSource && _react2.default.createElement(
                'div',
                { className: styles['review-item__info-source'] },
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'ReviewItem.source'
                }),
                ':\xA0',
                props.source
            )
        )
    );
};

ReviewItem.propTypes = {
    additionalClass: _propTypes2.default.string,
    content: _propTypes2.default.string,
    contentStyle: _propTypes2.default.object,
    date: _propTypes2.default.string,
    isReviewVerified: _propTypes2.default.bool,
    rate: _propTypes2.default.number,
    showSource: _propTypes2.default.bool,
    showSpecialistImage: _propTypes2.default.bool,
    showSpecialistInfo: _propTypes2.default.bool,
    showSpecialistName: _propTypes2.default.bool,
    source: _propTypes2.default.string,
    specialistImage: _propTypes2.default.string,
    specialistName: _propTypes2.default.string,
    wrapperStyle: _propTypes2.default.object
};

ReviewItem.defaultProps = {
    content: '',
    contentStyle: {},
    date: new Date().getDate() + '/' + (new Date().getMonth() + 1) + '/' + new Date().getFullYear(),
    isReviewVerified: false,
    showSource: false,
    showSpecialist: false,
    showSpecialistName: false,
    showSpecialistImage: false,
    wrapperStyle: {}

};

exports.default = (0, _intlProviderWrapper2.default)(ReviewItem);